import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 13 12\" id=\"checkmark\">\n  <path fill=\"currentcolor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.54.158a1 1 0 01.302 1.382l-6.408 10a1 1 0 01-1.484.227L.358 7.92a1 1 0 111.284-1.534l3.72 3.117L11.159.46A1 1 0 0112.54.158z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol